import { SetStateAction, useEffect } from 'react';
import { GET_CITY_LINK_INTERFACE } from '../../api/cityReviewLinks';
import Image from 'next/image';
import dynamic from 'next/dynamic';
const Link = dynamic(() => import('next/link'));

interface IProps {
  data: GET_CITY_LINK_INTERFACE | undefined;
  show: boolean;
  setShow: React.Dispatch<SetStateAction<boolean>>;
  setShowFeedBack: React.Dispatch<SetStateAction<boolean>>;
}

const ReviewModal = ({ data, show, setShow, setShowFeedBack }: IProps) => {
  // @ts-ignore
  const gmLink = data?.city?.[0].product.citiesProducts[0].city.gmbLink.city;
  const contactName = ` ${data?.city[0]?.customer?.contactName
    .split(' ')[0]
    .charAt(0)}${data?.city[0].customer.contactName
    .split(' ')[0]
    .slice(1)
    .toLowerCase()}`;

  return (
    <>
      {show && (
        <div
          id="modal-wrapper"
          className="fixed top-0 left-0 h-full w-full z-50 bg-[#2125292d] flex justify-center items-center"
          onClick={(e: any) => {
            if (e.target.id === 'modal-wrapper') {
              setShow(false);
            }
          }}
        >
          <div id="modal" className="relative bg-white rounded-md max-w-[85%]">
            <div className="p-8">
              <div className="absolute top-1 right-1">
                <Image
                  src="https://res.cloudinary.com/see-sight-tours/image/upload/v1685544129/Remaining%20images/Reviews/radix-icons_cross-2_mlrxew.svg"
                  width={25}
                  height={25}
                  alt="close-button"
                  className="ml-auto cursor-pointer     "
                  onClick={() => setShow(false)}
                />
              </div>
              <h2 className=" text-2xl lg:text-3xl text-center text-[#374045] font-normal animate-pulse">{`Hey ${
                contactName ? contactName : ''
              }, did you enjoy your tour?`}</h2>
              <div className="flex justify-between gap-3 mt-8">
                <button className="w-[40%] bg-blue-400 p-2 rounded-md text-white text-xl">
                  <Link target="_blank" href={gmLink ? gmLink : {}}>
                    Yes &#129321;
                  </Link>
                </button>

                <button
                  onClick={() => {
                    setShow(false);
                    setShowFeedBack(true);
                  }}
                  className="w-[40%] bg-blue-500 p-2 rounded-md text-white text-xl"
                >
                  No &#128542;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReviewModal;
